<template>
  <span v-if="pages.length && pages.length > 0">
    <span v-if="pages.length === ANNOUNCEMENT_PAGES.length">
      {{ 'announcement-detail.lbl-any-pages' | globalize }}
    </span>
    <span v-else>
      <a-tag
        v-for="page in pages"
        :key="`${page.value}`"
      >
        {{ page.label }}
      </a-tag>
    </span>
  </span>
  <span v-else>
    {{ 'announcement-detail.lbl-any-pages' | globalize }}
  </span>
</template>

<script>

import ATag from 'ant-design-vue/lib/tag'
import {
  ANNOUNCEMENT_PAGES,
} from '@/js/records/entities/announcement.record'
import 'ant-design-vue/lib/tag/style/index.css'

export default {
  name: 'announcement-pages',
  components: {
    ATag,
  },
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      ANNOUNCEMENT_PAGES,
    }
  },
}
</script>
